var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone 2",
    clipPath: "url(#clip0_274_769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 8.66667C5.55556 11.7778 8.22222 14.3333 11.3333 16L13.7778 13.5556C14.1111 13.2223 14.5556 13.1112 14.8889 13.3333C16.1111 13.7778 17.4444 14 18.8889 14C19.5556 14 20 14.4444 20 15.1111V18.8889C20 19.5556 19.5556 20 18.8889 20C8.44444 20 0 11.5556 0 1.11111C0 0.444444 0.444444 0 1.11111 0H5C5.66667 0 6.11111 0.444444 6.11111 1.11111C6.11111 2.44444 6.33333 3.77778 6.77778 5.11111C6.88889 5.44444 6.77778 5.88889 6.55556 6.22222L4 8.66667Z",
    fill: "#00A3FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.ce0952b65265ec18d0cb4dd117c64325.svg";
export { ForwardRef as ReactComponent };